export default {
  justNow: "방금 전",
  minutesAgo: "{{count}}분 전",
  hoursAgo: "{{count}}시간 전",
  daysAgo: "{{count}}일 전",
  submitting: "제출 중...",
  loading: "로딩 중...",
  error: "오류가 발생했습니다",
  title: "제목",
  titlePlaceholder: "제목을 입력하세요",
  content: "내용",
  contentPlaceholder: "내용을 입력하세요",
  category: "카테고리",
  submit: "제출",
  cancel: "취소",
  delete: "삭제",
  back: "뒤로",
  share: "공유",
  save: "저장",
  won: "원",
  logout: "로그아웃",
  noData: "데이터가 없습니다",
  linkCopied: "링크가 복사되었습니다",
  shareError: "공유에 실패했습니다",
  errorLoading: "로딩에 실패했습니다",
  deleting: "삭제 중...",
  draftSaved: "임시 저장되었습니다",
  clearHistory: "기록 삭제",
  noHistory: "기록이 없습니다",
  clearHistoryConfirm: "기록을 모두 삭제하시겠습니까?",
  checkHistory: "판별 기록",
  location: "위치",
  locationPlaceholder: "위치를 입력하세요",
  chargedAmount: "청구 금액",
  fairAmount: "적정 금액",
  writeReport: "신고 작성",
  sortLatest: "최신순",
  sortPopular: "인기순",
  sortComments: "댓글순",
  app: {
    name: "바가지 알림"
  },
  bottomNav: {
    home: "홈",
    planner: "플래너",
    boards: "게시판",
    checker: "판별기",
    profile: "마이",
    map: "지도"
  },
  mapExplore: {
    title: "지도 탐색",
    festival: "축제",
    performance: "공연",
    loading: "지도 데이터를 불러오는 중...",
    resultCount: "총 {{count}}개",
    viewDetail: "상세보기"
  },
  common: {
    loading: "로딩 중...",
    error: "오류가 발생했습니다",
    save: "저장",
    cancel: "취소",
    delete: "삭제",
    edit: "수정",
    confirm: "확인",
    back: "뒤로",
    next: "다음",
    submit: "제출",
    search: "검색",
    filter: "필터",
    sort: "정렬",
    share: "공유",
    report: "신고",
    like: "좋아요",
    comment: "댓글",
    view: "보기",
    more: "더보기",
    close: "닫기",
    login: "로그인",
    logout: "로그아웃",
    signup: "회원가입",
    email: "이메일",
    password: "비밀번호",
    name: "이름",
    phone: "전화번호",
    address: "주소",
    date: "날짜",
    time: "시간",
    location: "위치",
    category: "카테고리",
    title: "제목",
    content: "내용",
    image: "이미지",
    video: "동영상",
    file: "파일",
    upload: "업로드",
    download: "다운로드",
    won: "원",
    about: "약",
    total: "총",
    unknownRegion: "알 수 없는 지역",
    people: "명",
    retry: "다시 시도",
    unknown: "알 수 없음",
    all: "전체"
  },
  comment: {
    success: "댓글이 등록되었습니다",
    error: "댓글 등록에 실패했습니다",
    title: "댓글",
    empty: "댓글이 없습니다",
    placeholder: "댓글을 입력하세요",
    loginRequired: "로그인이 필요합니다",
    submit: "댓글 등록",
    editSuccess: "댓글이 수정되었습니다",
    replyButton: "답글",
    reply: "답글"
  },
  home: {
    title: "바가지 알림",
    searchPlaceholder: "검색어를 입력하세요",
    scamChecker: "바가지 판별기",
    scamCheckerDesc: "AI로 바가지 요금 확인하기",
    times: "{{count}}배",
    filters: {
      all: "전체",
      reports: "신고",
      tips: "꿀팁",
      popular: "인기"
    },
    sort: {
      latest: "최신순",
      popular: "인기순",
      comments: "댓글많은순"
    },
    writePost: "글쓰기",
    recentReports: "최근 신고",
    popularTips: "인기 꿀팁",
    noReports: "아직 신고가 없습니다",
    noTips: "아직 꿀팁이 없습니다",
    viewAll: "전체보기",
    filterAll: "전체",
    filterReport: "신고",
    filterTip: "꿀팁",
    filterPopular: "인기",
    sortLatest: "최신순",
    sortPopular: "인기순",
    sortComments: "댓글순",
    writeReport: "신고하기",
    writeTip: "꿀팁 작성"
  },
  scamCheck: {
    title: "바가지 판별기",
    subtitle: "AI가 적정 가격을 분석해드립니다",
    category: "카테고리",
    selectCategory: "카테고리를 선택하세요",
    enterInfo: "정보를 입력하세요",
    enterAmount: "결제 금액을 입력하세요",
    amount: "금액",
    detail: "상세 내용",
    charged: "청구",
    fair: "적정",
    chargedAmount: "청구 금액",
    chargedAmountPlaceholder: "금액을 입력하세요",
    checkButton: "판별하기",
    region: "지역",
    selectRegion: "지역을 선택하세요",
    location: "위치",
    locationPlaceholder: "예: 명동, 강남역",
    service: "서비스/상품명",
    servicePlaceholder: "예: 택시 이용, 호텔 숙박",
    details: "상세 내용 (선택)",
    detailsPlaceholder: "추가 정보를 입력해주세요",
    categories: {
      taxi: "택시",
      taxiDesc: "택시 요금 판별",
      accommodation: "숙박",
      accommodationDesc: "숙박 요금 판별",
      food: "음식점",
      foodDesc: "음식 가격 판별",
      shopping: "쇼핑",
      shoppingDesc: "쇼핑 가격 판별",
      tour: "관광",
      tourDesc: "관광 가격 판별",
      other: "기타",
      otherDesc: "기타 요금 판별"
    },
    taxi: {
      region: "지역",
      distance: "이동 거리 (km)",
      distanceRef: "거리 참고",
      distancePlaceholder: "예: 5",
      nightTime: "심야 시간 (00:00~04:00)"
    },
    accommodation: {
      region: "지역",
      type: "숙박 유형",
      peakSeason: "성수기",
      weekend: "주말",
      amount: "1박 요금"
    },
    food: {
      category: "음식 종류",
      menu: "메뉴",
      touristArea: "관광지 음식점",
      people: "인원 수",
      peoplePlaceholder: "예: 2",
      totalAmount: "총 결제 금액",
      totalAmountPlaceholder: "총 금액을 입력하세요",
      perPerson: "1인당 금액"
    },
    other: {
      item: "항목"
    },
    result: {
      title: "판별 결과",
      charged: "청구 금액",
      fair: "적정 금액",
      difference: "차이",
      ratio: "가격 비율",
      times: "{{count}}배",
      chargedAmount: "청구 금액",
      fairRange: "적정 가격 범위",
      fairPrice: "적정 가격",
      fairPriceDesc: "정상 가격 범위입니다",
      slightlyExpensive: "약간 비쌈",
      slightlyExpensiveDesc: "평균보다 다소 비싼 가격입니다",
      suspectedScam: "바가지 의심",
      suspectedScamDesc: "과다 청구가 의심됩니다",
      estimatedDistance: "예상 거리",
      nightSurcharge: "야간 할증 포함",
      longDistanceTip: "장거리 할증 적용 가능",
      peakSeasonSurcharge: "성수기 할증 포함",
      weekendSurcharge: "주말 할증 포함",
      perPerson: "1인당",
      yourPrice: "결제 금액",
      analysis: "분석 결과",
      reportButton: "신고하기",
      backButton: "다시 판별하기",
      shareButton: "결과 공유하기",
      howToDeal: "대처 방법",
      dealEvidence: "증거 확보",
      dealEvidenceDesc: "영수증, 사진, 영상을 촬영하세요",
      deal120: "120 다산콜센터",
      deal120Desc: "서울시 민원 상담 전화",
      dealApp: "앱에서 신고",
      dealAppDesc: "바가지 알림에서 바로 신고하세요",
      dealPolice: "경찰 신고",
      dealPoliceDesc: "심각한 경우 112에 신고하세요"
    }
  },
  boards: {
    title: "게시판",
    searchPlaceholder: "관광지, 축제, 음식점 검색...",
    eventFilter: "행사/축제",
    regionFilter: "지역별",
    reportCount: "신고 {{count}}건",
    tipCount: "꿀팁 {{count}}건",
    noBoards: "게시판이 없습니다",
    noReports: "신고글이 없습니다",
    noTips: "꿀팁이 없습니다",
    noLocalPosts: "현지 글이 없습니다",
    noSearchResults: "검색 결과가 없습니다",
    noFestivals: "해당 지역의 축제/행사가 없습니다",
    loadingFestivals: "축제 정보를 불러오는 중...",
    totalFestivals: "총 {{count}}개 축제/행사",
    loadMore: "더보기",
    searchingFor: "\"{{keyword}}\" 검색 중...",
    searchResultsCount: "\"{{keyword}}\" 검색 결과 {{count}}건",
    noSearchResultsFor: "\"{{keyword}}\"에 대한 검색 결과가 없습니다",
    tryOtherKeyword: "다른 키워드로 검색해 보세요",
    festivalStatus: {
      upcoming: "예정"
    },
    contentType: {
      tourist: "관광"
    },
    tabReports: "신고",
    tabTips: "꿀팁",
    tabLocal: "현지인"
  },
  planner: {
    title: "여행 플래너",
    createTrip: "새 여행 만들기",
    tripName: "여행 이름",
    tripNamePlaceholder: "예: 서울 여행",
    tripTitle: "여행 제목",
    tripTitlePlaceholder: "예: 서울 여행",
    startDate: "시작일",
    endDate: "종료일",
    createButton: "만들기",
    creating: "생성 중...",
    createError: "여행 생성에 실패했습니다",
    noTrips: "아직 여행 계획이 없습니다",
    myTrips: "내 여행",
    destination: "목적지",
    save: "저장",
    delete: "삭제",
    edit: "수정",
    dDay: "D",
    pleaseFillRequired: "필수 항목을 입력하세요",
    invalidDateRange: "종료일이 시작일보다 빠릅니다",
    addSchedule: "일정 추가",
    date: "날짜",
    time: "시간",
    scheduleTitle: "일정 제목",
    location: "위치",
    memo: "메모",
    editSchedule: "일정 수정",
    updateError: "일정 수정에 실패했습니다",
    updating: "수정 중..."
  },
  profile: {
    title: "마이페이지",
    editProfile: "프로필 수정",
    myReports: "내 신고",
    myTips: "내 꿀팁",
    myComments: "내 댓글",
    receivedLikes: "받은 좋아요",
    checkHistory: "판별 기록",
    myPosts: "작성한 글",
    login: "로그인",
    logout: "로그아웃",
    settings: "설정",
    language: "언어 설정",
    languages: {
      ko: "한국어",
      en: "English",
      ja: "日本語"
    },
    noPosts: "작성한 글이 없습니다",
    joinedAt: "가입일",
    loginRequired: "로그인이 필요합니다",
    pleaseLogin: "로그인하시면 모든 기능을 이용할 수 있습니다",
    loginButton: "로그인하기",
    languageSettings: "언어 설정",
    appVersion: "앱 버전",
    notification: "알림 설정",
    myFavorites: "즐겨찾기",
    favoriteAdded: "즐겨찾기에 추가되었습니다",
    favoriteRemoved: "즐겨찾기에서 제거되었습니다"
  },
  feed: {
    all: "전체",
    reports: "신고",
    tips: "꿀팁",
    popular: "인기",
    latest: "최신",
    mostLiked: "좋아요순",
    mostCommented: "댓글순",
    today: "오늘",
    yesterday: "어제",
    daysAgo: "{{count}}일 전",
    noContent: "아직 게시글이 없습니다"
  },
  post: {
    write: "글쓰기",
    edit: "수정",
    delete: "삭제",
    report: "신고",
    share: "공유",
    like: "좋아요",
    comment: "댓글",
    comments: "댓글",
    writeComment: "댓글을 작성하세요",
    submitComment: "등록",
    noComments: "댓글이 없습니다",
    deleteConfirm: "정말 삭제하시겠습니까?",
    reportConfirm: "이 게시글을 신고하시겠습니까?",
    reportSuccess: "신고가 접수되었습니다",
    deleteSuccess: "삭제되었습니다",
    writeReport: "신고 작성",
    writeTip: "꿀팁 작성"
  },
  report: {
    title: "신고 상세",
    category: "카테고리",
    location: "위치",
    locationPlaceholder: "예: 명동, 강남역",
    storeName: "상호명",
    storeNamePlaceholder: "예: OO식당",
    chargedAmount: "청구 금액",
    chargedAmountPlaceholder: "원",
    fairAmount: "적정 금액",
    fairAmountPlaceholder: "원",
    content: "내용",
    contentPlaceholder: "상세 내용을 작성하세요",
    images: "사진 첨부",
    submitButton: "신고하기",
    submitSuccess: "신고가 등록되었습니다",
    description: "상세 내용",
    submit: "신고하기",
    evidence: "증거 사진",
    writeReport: "신고 작성",
    titleField: "제목",
    photos: "사진",
    uploadPhoto: "사진 업로드",
    maxPhotos: "최대 3장",
    pleaseFillRequired: "필수 항목을 입력하세요",
    success: "신고가 등록되었습니다",
    error: "신고 등록에 실패했습니다",
    edit: "수정",
    delete: "삭제",
    deleteConfirm: "이 신고를 삭제하시겠습니까?"
  },
  reportDetail: {
    overcharge: "{{ratio}}배 과다청구",
    like: "좋아요",
    comment: "댓글"
  },
  tip: {
    title: "꿀팁 작성",
    detailTitle: "꿀팁",
    category: "카테고리",
    location: "위치",
    locationPlaceholder: "예: 명동, 강남역",
    tipTitle: "제목",
    tipTitlePlaceholder: "제목을 입력하세요",
    content: "내용",
    contentPlaceholder: "꿀팁을 공유하세요",
    images: "사진 첨부",
    submitButton: "등록",
    submitSuccess: "꿀팁이 등록되었습니다",
    tags: "태그",
    submit: "꿀팁 등록",
    categoryAccommodation: "숙박",
    categoryTransport: "교통",
    categoryFood: "음식",
    categoryLocal: "현지 정보",
    categoryOther: "기타"
  },
  auth: {
    loginTitle: "로그인",
    signupTitle: "회원가입",
    email: "이메일",
    password: "비밀번호",
    nickname: "닉네임",
    loginButton: "로그인",
    signupButton: "회원가입",
    switchToSignup: "계정이 없으신가요? 회원가입",
    switchToLogin: "이미 계정이 있으신가요? 로그인",
    loginSuccess: "로그인되었습니다",
    signupSuccess: "회원가입이 완료되었습니다",
    error: "오류가 발생했습니다",
    logout: "로그아웃"
  },
  validation: {
    required: "필수 항목입니다",
    email: "올바른 이메일을 입력하세요",
    password: "비밀번호는 6자 이상이어야 합니다",
    number: "숫자만 입력하세요"
  },
  currency: {
    won: "원"
  }
};
